import { useRef, useState } from "react";
import './input-heated-segments.css'
import type { HeatedSegment } from "../state/properties.ts";

export default function HeatedSegments (props: {
	label: string,
  hint: string,
	value: HeatedSegment,
  onChange: (value: HeatedSegment) => void
}){
  return <div className={"heated-segments"}>
         <label className={"heated-segments__label input__label"}>{props.label}
          <span className={"heated-segments__hint"}>{props.hint}
        </span></label>
         <div className="heated-segments__container">
            <div className={"heated-segments__inputs"}>
              <Input value={props.value[0]} onChange={(value) => {
                const new_value : [number, number, number] = [...props.value];
                new_value[0] = value;
                props.onChange(new_value);
              }} />
              <Input value={props.value[1]} disabled onChange={(value) => {}} />
              <Input value={props.value[2]} onChange={(value) => {
                const new_value :[number, number, number]  = [...props.value];
                new_value[2] = value;
                props.onChange(new_value);
              }} />
          </div>
         </div>
  </div>
}

export function Input (props: {
	value: number,
  onChange: (value: number) => void,
}){
  const selfRef = useRef(null);
  const [draggingStartValue, setDraggingStartValue] = useState<number>(0);
  const [draggingStart, setDraggingStart] = useState<number | undefined>(undefined);
  return <div ref={selfRef} className={"heated-segment-input"} 
  onPointerDown={(e)=>{
    if(selfRef.current !== null){
      // @ts-ignore:TS2339
      selfRef.current.setPointerCapture(e.pointerId);
    }
    setDraggingStartValue(props.value);
    setDraggingStart(e.clientX);
  }} 
  onPointerMove={(e)=>{
    if(draggingStart){
      if(selfRef.current !== null){
        // @ts-ignore:TS2339
        const new_value =  Math.min(100, Math.max(0, draggingStartValue + Math.round(((e.clientX - draggingStart) / selfRef.current.offsetWidth) * 100)));
        props.onChange(new_value);
      }
    }
  }} 
  onPointerUp={(e)=>{
    setDraggingStart(undefined);
    if(selfRef.current !== null){
      // @ts-ignore:TS2339
          selfRef.current.releasePointerCapture(e.pointerId);
    }
  }}
  onPointerLeave={(_e)=>{setDraggingStart(undefined)}}
  >
        <div className={"heated-segment-input__fill"} style={{width:props.value+"%"}}></div>
        <input className={"heated-segment-input__input" + (draggingStart ? " heated-segment-input--dragged" : "")} value={props.value} onChange={(e)=>{
          const value = Math.min(100, Math.max(0, parseInt(e.target.value)));
          props.onChange(Number.isNaN(value) ? 100 : value);
        }}/>
    </div>
}
